import { rem } from "@affinity/constants/StyleHelpers";
import WidgetRenderer from "@insite/client-framework/Components/WidgetRenderer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getHeader } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getWidgetsByPageId } from "@insite/client-framework/Store/Data/Widgets/WidgetSelectors";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import React from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";

const LogoWrapper = styled.div`
    max-width: ${rem(114)};
`;

export const DrawerHeaderLogo: React.FC<{ onClick?: () => void }> = ({ onClick }) => {
    const logo = useSelector((state: ApplicationState) => {
        const headerPage = getWidgetsByPageId(state, getHeader(state).id);
        const logo = headerPage.find((widget: WidgetProps) => {
            return widget.type === "Basic/Logo";
        });
        return logo;
    });

    if (!logo) {
        return null;
    }

    return (
        <LogoWrapper onClick={onClick}>
            <WidgetRenderer
                key={logo.id}
                id={logo.id}
                type={logo.type}
                fixed={false}
                isLayout={logo.isLayout}
                pageId={logo.parentId}
            />
        </LogoWrapper>
    );
};
